export var ESortingOption;
(function (ESortingOption) {
    ESortingOption[ESortingOption["default"] = 0] = "default";
    ESortingOption[ESortingOption["asc"] = 1] = "asc";
    ESortingOption[ESortingOption["desc"] = 2] = "desc";
})(ESortingOption || (ESortingOption = {}));
